import colors from 'assets/styles/jsVariables/colors';

export default {
  AuthButtonStyle: {
    height: '45px',
    width: '200px',
    margin: 'auto',
    display: 'inline-block',
    '@media (max-width: 767px)': {
      display: 'block',
    },
    borderRadius: '22.5px'
  },
  AuthButtonLabelStyle: {
    fontFamily: 'museosansrounded_500',
    fontSize: '14px',
    letterSpacing: '0.3px',
    textTransform: 'none'
  },
  inputStyle: {
    borderBottom: `${colors.lighterCyan} 2px solid`,
    '&::placeholder': {
      color: '#cecece'
    }
  },
  modalStyleVerifyEmail: {
    titleStyle: { textAlign: 'center', marginTop: '19px' },
    paperStyle: { borderRadius: '10px', maxWidth: '680px', width: '100%' },
    titleContainerStyle: { paddingLeft: 20, paddingRight: 20 },
    childrenStyle: {
      overflowY: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 73
    },
    containerStyle: { zIndex: 999999999 }
  },
  modalStyleResetPasswordEmail: {
    titleStyle: { textAlign: 'center', marginTop: '19px' },
    paperStyle: { borderRadius: '10px', maxWidth: '680px', width: '100%' },
    titleContainerStyle: { paddingLeft: 20, paddingRight: 20 },
    childrenStyle: {
      overflowY: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: '42px'
    },
  },
  AuthFormSelectedTabStyle: {
    border: `1px solid ${colors.lighterCyan}`,
    backgroundColor: colors.lighterCyan,
    color: colors.white
  },
  AuthFormUnSelectedTabStyle: {
    border: `1px solid ${colors.lighterCyan}`
  },
  AuthEnableButtonStyle: colors.lighterCyan,
  AuthDisableButtonStyle: colors.disabledLighterCyan,
  AuthFormLogoStyle: '244px'
};



// WEBPACK FOOTER //
// ./src/components/Auth/style.js